/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type ProjectSettingsServiceDeskInternalNotificationsType from '@jira/spa-apps__project-settings-service-desk-internal-notifications/src/ExportedDefault.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';
import type {
	Location,
	Query,
	Route,
	Match,
	HistoryAction,
} from '@atlassian/react-resource-router';

export const LazyProjectSettingsServiceDeskInternalNotifications: LazyComponent<{
	(props: {
		location: Location;
		query: Query;
		route: Route;
		match: Match;
		action: HistoryAction;
	}): React.JSX.Element;
	displayName: string;
}> = lazyForPaint<typeof ProjectSettingsServiceDeskInternalNotificationsType>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-project-settings-service-desk-internal-notifications", jiraSpaEntry: "async-project-settings-service-desk-internal-notifications" */ '@jira/spa-apps__project-settings-service-desk-internal-notifications/src/ExportedDefault.tsx'
		),
	),
);

const AsyncProjectSettingsServiceDeskInternalNotifications = (): React.JSX.Element => (
	<LazyPage
		Page={LazyProjectSettingsServiceDeskInternalNotifications}
		pageId="project-settings-internal-notifications"
		shouldShowSpinner
	/>
);

export default AsyncProjectSettingsServiceDeskInternalNotifications;
